import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonInternalSignedOutWidget, EnvironmentService, ErrorService, InternalAuthService, SpinnerService, UrlService, UtilityService } from '@eforall/common';
import { DashboardErrorPart, DashboardFrameService, DashboardSpinnerWidget } from '@eforall/dashboard';
import { NgbModule, NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../environments';
import { AppService, DomainDataService } from '../../services';
import { getDashboardFrameConfig } from './get-dashboard-frame-config';


@Component({
	selector: 'bootstrap-page',
	imports: [
		DashboardErrorPart,
		DashboardSpinnerWidget,
		CommonInternalSignedOutWidget,
		NgbModule,
		RouterOutlet,
	],
	templateUrl: `bootstrap.page.html`,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class BootstrapPage {

	public spinnerService = inject(SpinnerService);
	public errorService = inject(ErrorService);

	private env = inject(EnvironmentService);
	public auth = inject(InternalAuthService);
	private router = inject(Router);
	private util = inject(UtilityService);
	private urlService = inject(UrlService);
	private ngbTooltipConfig = inject(NgbTooltipConfig);
	private frame = inject(DashboardFrameService);

	// private pwa = inject(PwaService);

	public app = inject(AppService);
	public domainData = inject(DomainDataService);





	constructor() {

		this.auth.setData(
			this.app.loadData.bind(this.app),
			this.app.clearData.bind(this.app),
			this.domainData.loadDomainData.bind(this.domainData),
			this.domainData.clearDomainData.bind(this.domainData),
		);

		this.env.setEnvironment(environment);

		this.setNgbTooltipConfig();

		this.intializeFrame();
	}

	private intializeFrame() {
		this.frame.initialize(getDashboardFrameConfig(this.auth));
	}


	private setNgbTooltipConfig() {
		this.ngbTooltipConfig.triggers = 'hover';
		this.ngbTooltipConfig.openDelay = 2000;
		this.ngbTooltipConfig.closeDelay = 100;
	}
}
